module.exports = __webpack_public_path__ + "img/aston-apply.b276f7b9.jpg";